module.exports = __webpack_public_path__ + "static/img/custom.201aca2a.png";